// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New employee page (Stitch: New employee) ——— */
.employee-form-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 0 0 48px;
  background: #ffffff;
  overflow-x: hidden;
}

.employee-form-page__header {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  padding: 24px 32px 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.employee-form-page__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.3;
}

.employee-form-page__breadcrumb .lucide {
  color: #94A3B8;
  flex-shrink: 0;
}

[dir='rtl'] .employee-form-page__breadcrumb .lucide {
  transform: scaleX(-1);
}

.employee-form-page__crumb {
  color: #64748B;
  text-decoration: none;
  transition: color 0.12s ease;
}

.employee-form-page__crumb:hover {
  color: #0EA5E9;
}

.employee-form-page__crumb--muted {
  pointer-events: none;
}

.employee-form-page__crumb--current {
  color: #0EA5E9;
  font-weight: 500;
}

.employee-form-page__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.employee-form-page__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.employee-form-page__back:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

[dir='rtl'] .employee-form-page__back .lucide {
  transform: scaleX(-1);
}

.employee-form-page__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.employee-form-page__canvas {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 24px 32px 24px;
}

.employee-form-page__canvas .employee-form {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.employee-form-page__hint {
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.45;
  max-width: 36rem;
}

.employee-form-page__hint-dot {
  color: #F43F5E;
  font-weight: 600;
  flex-shrink: 0;
}

.employee-form-page__hint .employee-form__req {
  font-weight: 600;
}

.employee-form-page__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
}

.employee-form-page__footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-inline-start: auto;
}

.employee-form-page__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.employee-form-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.employee-form-page__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.employee-form-page__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  border-color: #CBD5E1;
  color: #0F172A;
}

.employee-form-page__btn--primary {
  padding-inline: 16px;
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 500;
}

.employee-form-page__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.employee-form-page__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
  font-size: 11px;
  color: #94A3B8;
}

.employee-form-page__meta-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.employee-form-page__meta-sep {
  color: #CBD5E1;
}

.employee-form-page__meta-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

@media (max-width: 720px) {
  .employee-form-page__header,
  .employee-form-page__canvas {
    padding-left: 16px;
    padding-right: 16px;
  }

  .employee-form-page__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .employee-form-page__footer-actions {
    margin-inline-start: 0;
    width: 100%;
  }

  .employee-form-page__btn {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewEmployee/style.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ——— New employee page (Stitch: New employee) ——— */\n.employee-form-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 0 0 48px;\n  background: #ffffff;\n  overflow-x: hidden;\n}\n\n.employee-form-page__header {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  padding: 24px 32px 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.employee-form-page__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.employee-form-page__breadcrumb .lucide {\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n[dir='rtl'] .employee-form-page__breadcrumb .lucide {\n  transform: scaleX(-1);\n}\n\n.employee-form-page__crumb {\n  color: #64748B;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.employee-form-page__crumb:hover {\n  color: #0EA5E9;\n}\n\n.employee-form-page__crumb--muted {\n  pointer-events: none;\n}\n\n.employee-form-page__crumb--current {\n  color: #0EA5E9;\n  font-weight: 500;\n}\n\n.employee-form-page__title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.employee-form-page__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.employee-form-page__back:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n[dir='rtl'] .employee-form-page__back .lucide {\n  transform: scaleX(-1);\n}\n\n.employee-form-page__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.employee-form-page__canvas {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 24px 32px 24px;\n}\n\n.employee-form-page__canvas .employee-form {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.employee-form-page__hint {\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.45;\n  max-width: 36rem;\n}\n\n.employee-form-page__hint-dot {\n  color: #F43F5E;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.employee-form-page__hint .employee-form__req {\n  font-weight: 600;\n}\n\n.employee-form-page__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  padding-top: 20px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.employee-form-page__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-inline-start: auto;\n}\n\n.employee-form-page__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.employee-form-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.employee-form-page__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.employee-form-page__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n  color: #0F172A;\n}\n\n.employee-form-page__btn--primary {\n  padding-inline: 16px;\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.employee-form-page__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.employee-form-page__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.employee-form-page__meta-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.employee-form-page__meta-sep {\n  color: #CBD5E1;\n}\n\n.employee-form-page__meta-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n@media (max-width: 720px) {\n  .employee-form-page__header,\n  .employee-form-page__canvas {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .employee-form-page__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .employee-form-page__footer-actions {\n    margin-inline-start: 0;\n    width: 100%;\n  }\n\n  .employee-form-page__btn {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
